import { proxy, useSnapshot } from 'valtio'
import { createBus } from './util'

export const state = proxy({
  adding: {
    type: '',
    over: '',
    startX: 0,
    startY: 0,
  },
  connecting: {
    sourceId: '',
  },
})

export function useAppState() {
  const s = useSnapshot(state)
  return s
}

export const events = createBus()
